// extracted by mini-css-extract-plugin
export default {"saveIconUpdateVariant":"_ba105b1","icon":"_69d2b576","favoritesItemProvider":"_af4bb36e"};